import type { SimulationPlaybackCluster } from './simulationPlayback';

const safeNonNegative = (value: number): number =>
  Math.max(0, Number.isFinite(value) ? value : 0);

export const getDisplayWidthM = (actualWidthM: number, apertureExaggeration: number): number =>
  safeNonNegative(actualWidthM) * safeNonNegative(apertureExaggeration);

export const resolveFractureVerticalExtents = (
  cluster: Pick<SimulationPlaybackCluster, 'heightM' | 'upperHeightM' | 'lowerHeightM'>,
): { upperM: number; lowerM: number } => {
  // Prefer the P3D solver's real upper/lower extents when present. Legacy
  // results expose total height only; those remain centred on the perforation
  // without inventing directional asymmetry.
  const heightM = safeNonNegative(cluster.heightM);
  const upperM = cluster.upperHeightM === undefined
    ? (cluster.lowerHeightM === undefined ? heightM / 2 : Math.max(0, heightM - safeNonNegative(cluster.lowerHeightM)))
    : safeNonNegative(cluster.upperHeightM);
  const lowerM = cluster.lowerHeightM === undefined
    ? (cluster.upperHeightM === undefined ? heightM / 2 : Math.max(0, heightM - safeNonNegative(cluster.upperHeightM)))
    : safeNonNegative(cluster.lowerHeightM);
  return { upperM, lowerM };
};
